import styled from "styled-components";

const ActionArea = styled.div`
  margin-top: 10px;
`;
export default ActionArea;
